import { render, staticRenderFns } from "./CreateFa.vue?vue&type=template&id=3f76010e&scoped=true"
import script from "./CreateFa.vue?vue&type=script&lang=js"
export * from "./CreateFa.vue?vue&type=script&lang=js"
import style0 from "./CreateFa.vue?vue&type=style&index=0&id=3f76010e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f76010e",
  null
  
)

export default component.exports